import ga from '../utils/ga'

// https://github.com/envato/marketplace/blob/master/app/assets/javascripts/market/shared/google_analytics/_promo.js.coffee
export const reportHeaderBannerClick = (payload: { name: string }) => {
  ga('ec:addPromo', payload)
  ga('ec:setAction', 'promo_click')
  ga('send', 'event', 'Internal Promotions', 'click', {
    label: payload.name
  })
}

export const reportHeaderBannerClose = (payload: { name: string }) => {
  ga('ec:addPromo', payload)
  ga('ec:setAction', 'promo_click')
  ga('send', 'event', 'Banner Impression', 'close', {
    label: payload.name
  })
}

export const reportHeaderBannerImpression = (payload: {
  id: string
  name: string
}) => {
  ga('ec:addImpression', payload)
  ga('send', 'event', 'Banner Impression', 'view', {
    id: payload.id,
    label: payload.name
  })
}
